import { atom } from "recoil";
import { Note } from "types/models";

export const listOfNotesState = atom<Note[]>({
  key: "listOfNotesState",
  default: [],
});
